module.exports = __webpack_public_path__ + "images/b801030cf26b2ad4e7eb4a82180fd0b3-ab-mapCluster.png";